type Theme = 'light' | 'dark' | 'system';

const KEY = 'theme';

export function getStoredTheme(): Theme {
  if (typeof localStorage === 'undefined') return 'system';
  const v = localStorage.getItem(KEY);
  return v === 'light' || v === 'dark' ? v : 'system';
}

export function setTheme(t: Theme) {
  const root = document.documentElement;
  root.classList.remove('dark', 'light');
  if (t === 'dark') root.classList.add('dark');
  if (t === 'light') root.classList.add('light');
  try {
    if (t === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, t);
  } catch {}
}

export function bootTheme(): void {
  setTheme(getStoredTheme());
}
